<template>
    <div>
        <div class="flex-col">
            <transition
                name="fade"
                mode="out-in">
                <div v-if="itemsReport && itemsReport?.items && !loading">
                    <div>
                        <h4 class="flex justify-between items-center">
                            <p class="pl-2">
                                {{ itemsReport.name }}
                            </p>
                            <span class="ml-2">
                                <hi-arrow-path-rounded-square-icon
                                    class="w-8 h-8 cursor-pointer text-gray-400 hover:text-gray-600"
                                    @click="clearTemplateStatistic" />
                            </span>
                        </h4>

                        <div class="grid grid-cols-4 gap-4 mt-5">
                            <div
                                v-for="(item, index) in itemsReport.items"
                                :key="index"
                                class="relative group hover:shadow-2xl transition-shadow duration-300"
                                :class="getClassByTypeReport(item.typeReport)">
                                <report-management
                                    :module="item.type"
                                    :type-report="item.typeReport"
                                    :class="{ 'p-2': item.typeReport === 'work' }" />
                                <div class="absolute top-0 left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <hi-x-circle-icon
                                        class="h-6 w-6 text-error-400 hover:text-error-600 transition-all cursor-pointer"
                                        @click="deleteChartReport(item, index)" />
                                </div>
                            </div>
                            <div class="h-[220px] hover:shadow-2xl col-span-2 justify-center flex flex-wrap content-center bg-clip-border rounded-xl bg-white shadow">
                                <hi-plus-circle-icon
                                    class="h-32 w-32 cursor-pointer text-gray-300 hover:text-gray-500 duration-300"
                                    @click="handleOpenPopupEditTypeReport" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <h4 class="mb-5">
                        {{ $t('labels.templateReport') }}
                    </h4>
                    <hts-form-button
                        color="main"
                        icon-name="hi-plus-circle-icon"
                        icon-position="right"
                        class="mb-5"
                        @click="handleOpenPopupAddTypeReport">
                        {{ $t('labels.add') }}
                    </hts-form-button>
                    <ul class="list-decimal pl-5">
                        <li
                            v-for="(templateStatistic, index) in allTemplateStatistic"
                            :key="templateStatistic">
                            <div class="flex justify-start items-center">
                                <div class="flex justify-start items-center group">
                                    <span
                                        class="text-ellipsis overflow-hidden text-primary-500 underline cursor-pointer m-0 py-1"
                                        @click="changeTemplateStatistic(templateStatistic)">
                                        {{ templateStatistic.name }}
                                    </span>
                                    <hi-x-circle-icon
                                        class="h-6 w-6 cursor-pointer min-w-5 ml-5 text-error-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                                        @click.stop.prevent="deleteTypeReport(templateStatistic)" />
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </transition>
        </div>
        <hts-drawer
            v-model="openPopupSetting"
            color="main"
            :submit="handleSubmitSetting"
            title="Setting Report"
            :size="60"
            @close="openPopupSetting = false">
            <div>
                <hts-draggable
                    v-if="itemSetting && itemSetting.length"
                    v-model="itemSetting"
                    :options="{ animation: 200 }">
                    <div
                        v-for="(item, index) in itemSetting"
                        :key="index"
                        class="mt-2">
                        <div class="drag-item bg-default-100 dark:bg-default-600 px-3 py-1 box-border rounded-xl w-full flex items-center">
                            <span>
                                {{ labelTypeReport[item.typeReport] }} - {{ labelModuleReport[item.type] }}
                            </span>
                        </div>
                    </div>
                </hts-draggable>
                <div class="flex mt-2 text-main-600">
                    <div
                        class="flex cursor-pointer"
                        @click="handleOpenPopupEditTypeReport">
                        <hi-plus-circle-icon class="h-5 w-5" />
                        <span>
                            {{ $t('labels.add1') }}
                        </span>
                    </div>
                </div>
            </div>
        </hts-drawer>
        <hts-modal
            :show="openPopupEditTypeReport"
            @close="openPopupEditTypeReport = false">
            <template #custom>
                <hts-form
                    class="space-y-6"
                    @submit="addCustomTypeReport">
                    <hts-form-select
                        v-model="formAddTypeReportSearch.key"
                        :items="typeReportItems"
                        :label="$t('labels.typeReport')"
                        required
                        key-disabled="disabled"
                        key-id="key"
                        key-label="label" />

                    <hts-form-select
                        v-model="formAddTypeReportSearch.type"
                        :items="CClassItemsEditCustom"
                        :disabled="!formAddTypeReportSearch.key"
                        :label="$t('labels.type')"
                        required
                        key-disabled="disabled"
                        key-id="key"
                        key-label="label" />
                    <div class="flex justify-end">
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            type="submit"
                            :loading="false">
                            {{ $t('labels.save') }}
                        </hts-form-button>

                        <hts-form-button
                            class="pl-2"
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="openPopupEditTypeReport = false">
                            {{ $t('labels.cancel') }}
                        </hts-form-button>
                    </div>
                </hts-form>
            </template>
        </hts-modal>

        <hts-modal
            :show="openPopupAddTypeReport"
            @close="openPopupAddTypeReport = false">
            <template #custom>
                <hts-form
                    class="space-y-6"
                    @submit="createDataReport">
                    <hts-form-input
                        v-model="formSearch.name"
                        :label="$t('labels.name')"
                        required />
                    <template v-if="formSearch.items && Array.isArray(formSearch.items)">
                        <div
                            v-for="(item, index) in formSearch.items"
                            :key="index"
                            class="flex space-x-1 items-center">
                            <hts-form-select
                                v-model="item.typeReport"
                                class="w-1/2"
                                :items="CTypeItems"
                                :label="$t('labels.typeReport')"
                                required
                                key-disabled="disabled"
                                name="typeReport"
                                :prop="'typeReport' + index"
                                key-id="key"
                                key-label="label" />
                            <hts-form-select
                                v-model="item.type"
                                multiple
                                class="w-1/2"
                                :items="classItems"
                                :label="$t('labels.type')"
                                required
                                name="type"
                                :prop="'type' + index"
                                key-id="key"
                                key-label="label" />
                            <div
                                v-if="formSearch.items.length > 1"
                                class="mt-6 ml-2">
                                <hi-x-circle-icon
                                    class="h-6 w-6 text-error-600 cursor-pointer"
                                    @click="(e) => deleteModule(e, index)" />
                            </div>
                        </div>
                    </template>
                    <div class="flex text-main-600">
                        <div
                            class="flex cursor-pointer"
                            @click="addModule">
                            <hi-plus-circle-icon class="h-5 w-5" />
                            <span>
                                {{ $t('labels.add1') }}
                            </span>
                        </div>
                    </div>
                    <div class="flex justify-end">
                        <hts-form-button
                            icon-name="hi-check-icon"
                            icon-position="right"
                            color="primary"
                            type="submit"
                            :loading="false">
                            {{ $t('labels.save') }}
                        </hts-form-button>

                        <hts-form-button
                            class="pl-2"
                            icon-name="hi-x-mark-icon"
                            icon-position="right"
                            color="error"
                            @click="() => (openPopupAddTypeReport = false)">
                            {{ $t('labels.cancel') }}
                        </hts-form-button>
                    </div>
                </hts-form>
            </template>
        </hts-modal>
    </div>
</template>

<script setup lang="ts">
import data from './-components/ignore/imports/data'
import ReportManagement from './-components/report-management.vue'
import ReportChard from './-components/report-chart.vue'
import ReportDetailTable from './-components/report-detail-table.vue'
import { $api, $lodash } from '#imports'
const store = $store()

const itemsReport = computed(() => {
  return store.report.getTemplateStatistic
})

const allTemplateStatistic = ref<{ [key: string]: any }[]>([])
const loading = ref(false)
const selectTypeReport = ref()
const itemSetting = ref<Array<{ [key: string]: any }>>([])
const formAddTypeReportSearch = ref({
  type: '',
  key: ''
})
const openPopupAddTypeReport = ref(false)
const defaultItems = {
  name: '',
  items: [
    {
      type: [],
      typeReport: '',
      daterange: []
    }
  ]
}
const formSearch = ref($lodash.cloneDeep(defaultItems))

onMounted(async () => {
  await getAllTemplateStatistic()
})

const changeTemplateStatistic = $lodash.debounce(async (item: any) => {
  loading.value = true

  const api = $url.statistic.chooseStatisticTemplate
  const res = await $api(api, {
    uriParams: {
      ID: item._id
    }
  })
  const resData: any = res?.data.value

  if (resData?.success) {
    store.report.setTemplateStatistic(item)
  }

  loading.value = false
}, 100)

const clearTemplateStatistic = $lodash.debounce(async () => {
  loading.value = true

  const api = $url.statistic.deleteChooseStatisticTemplate
  const res = await $api(api)
  const resData: any = res?.data.value

  if (resData?.success) {
    store.report.setTemplateStatistic(null)
  }

  loading.value = false
}, 100)

const deleteChartReport = async (itemReport: string, index: number) => {
  itemsReport.value?.items.splice(index, 1)
  const result = await updateTemplateReport()
  if (result) {
    process.client && $toast().success($t('labels.deleteSuccess'))
  }
  await getAllTemplateStatistic()
}

const addCustomTypeReport = async () => {
  itemsReport.value?.items.push({
    typeReport: formAddTypeReportSearch.value.key,
    type: formAddTypeReportSearch.value.type
  })
  openPopupEditTypeReport.value = false
  formAddTypeReportSearch.value.key = ''
  formAddTypeReportSearch.value.type = ''
  const result = await updateTemplateReport()
  if (result) {
    process.client && $toast().success($t('labels.addSuccess'))
  }
  // await getAllTemplateStatistic()
}

const updateTemplateReport = async () => {
  const api = $url.statistic.updateTemplate
  const res = await $api(api, {
    uriParams: {
      ID: itemsReport.value._id
    },
    body: {
      items: itemsReport.value?.items
    }
  })
  const resData: any = res?.data.value
  if (resData?.success) {
    return true
  }
  selectTypeReport.value && (await selectTypeReport.value.getDataSelect())
  await getAllTemplateStatistic()
  return null
}

const openPopupEditTypeReport = ref(false)
const handleOpenPopupEditTypeReport = () => {
  itemSetting.value = $lodash.cloneDeep(itemsReport.value?.items)
  openPopupEditTypeReport.value = true
}

const classItemCustom = $lodash.cloneDeep(data().classItemSelect)
const typeReportItems = $lodash.cloneDeep(data().typeReportData)
const labelTypeReport = $lodash.cloneDeep(data().labelTypeReport)

const labelModuleReport = $lodash.cloneDeep(data().labelModuleReport)

const handleOpenPopupAddTypeReport = () => {
  openPopupAddTypeReport.value = true
}

const CClassItemsEditCustom = computed(() => {
  if (itemSetting.value && formAddTypeReportSearch.value.key) {
    const itemByKey = itemSetting.value.filter((item: { [key: string]: any }) => {
      return item.typeReport === formAddTypeReportSearch.value.key
    })

    const arrayTypeModule = $lodash.map(itemByKey, 'type')
    const arrayCopy = $lodash.cloneDeep(classItemCustom)
    classItemCustom.forEach((v: any, index: number) => {
      if (arrayTypeModule.includes(v.key)) {
        arrayCopy[index].disabled = true
      }
    })
    return arrayCopy
  }
  return []
})

const getClassByTypeReport = (typeReport: string) => {
  switch (typeReport) {
  case 'status':
    return 'col-span-2'
  case 'statistical':
    return 'col-span-2'
  case 'work':
    return 'col-span-4'
  }
}

const openPopupSetting = ref(false)

const handleSubmitSetting = async () => {
  itemsReport.value.items = itemSetting.value
  await updateTemplateReport()
  openPopupSetting.value = false
  await getAllTemplateStatistic()
}

const getAllTemplateStatistic = async () => {
  const api = $url.statistic.getAllStatistic
  const data: any = await $api(api)
  const resData = $lodash.get(data, 'data.value')
  if (resData.success) {
    allTemplateStatistic.value = resData.data.all || []
    store.report.setTemplateStatistic(resData.data.choose)
  } else {
    allTemplateStatistic.value = []
    store.report.setTemplateStatistic(null)
  }
}

const deleteTypeReport = async (item: { _id: string }) => {
  try {
    selectTypeReport.value && selectTypeReport.value.hide()
    const api = $url.statistic.delete
    const data: any = await $api(api, { uriParams: { ID: item._id } })
    const resData = data?.data?.value
    if (resData.success) {
      await getAllTemplateStatistic()
      process.client && $toast().success($t('labels.deleteSuccess'))
    }
  } catch (e: any) {}
}

const classItems = $lodash.cloneDeep(data().classItemSelect)

const CTypeItems = computed(() => {
  const pluckType = $lodash.map(formSearch.value.items, 'typeReport')
  const coppyArray = $lodash.cloneDeep(typeReportItems)
  typeReportItems.forEach((item: { [key: string]: any }, index: number) => {
    if (pluckType.includes(item.key)) {
      coppyArray[index].disabled = true
    }
  })
  return coppyArray
})

const addModule = () => {
  formSearch.value.items.push({
    type: [],
    typeReport: '',
    daterange: []
  })
}

const deleteModule = (e: any, index: number) => {
  e.preventDefault()
  e.stopPropagation()
  formSearch.value.items.splice(index, 1)
}

const createDataReport = async () => {
  loading.value = true
  try {
    const api = $url.statistic.create
    const data: any = await $api(api, { body: formSearch.value })
    const resData = data?.data?.value

    if (resData?.success) {
      formSearch.value = $lodash.cloneDeep(defaultItems)
      openPopupAddTypeReport.value = false
      await getAllTemplateStatistic()
      process.client && $toast().success($t('labels.addSuccess'))
    }

    loading.value = false
  } catch (e: any) {
    loading.value = false
  }
}
</script>
